import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'PageTitleDescription' })((theme) => ({
  root: {
    width: '100%',
  },
  padding: {
    padding: theme.spacing(2),
  },
  divider: {
    marginBottom: theme.spacing(1),
  },
  pageTitle: {
    fontSize: theme.typography.pxToRem(26),
    padding: theme.spacing(0, 0, 1, 0),
    color: theme.palette.text.primary,
  },
}));

export default useStyles;
